import React, { useState } from "react"
import { Clipboard, Check } from "lucide-react"

const EmailCopy = ({ email }) => {
    const [copied, setCopied] = useState(false)

    const handleCopy = () => {
        navigator.clipboard.writeText(email)
        setCopied(true)
        setTimeout(() => setCopied(false), 1500)
    }

    return (
        <div
            className="relative font-semibold cursor-pointer hover:text-blue-600
                 max-w-[520px] md:max-w-[660px] lg:max-w-[700px] truncate"
            onClick={handleCopy}
        >
            <span className="truncate">{email}</span>
            <span className="absolute right-0 top-1/2 -translate-y-1/2">
                {copied ? (
                    <Check className="w-4 h-4 text-green-600 flex-shrink-0" />
                ) : (
                    <Clipboard className="w-4 h-4 text-gray-500 flex-shrink-0" />
                )}
            </span>
        </div>
    )
}

export default EmailCopy
